export type ProductStatus = 'active' | 'inactive' | 'coming_soon';

export interface BaseResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
}

export const STATUS = {
  ACTIVE: 'active' as ProductStatus,
  INACTIVE: 'inactive' as ProductStatus,
  COMING_SOON: 'coming_soon' as ProductStatus,
};
